<template lang="pug">
.oval_img_item.d-flex
  img.flex-shrink-0(:src="img")
  p.i_body_l {{ title }}
</template>

<script>
export default {
  name: "OvalImgItem",
  props: {
    title: String,
    img: String,
  },
};
</script>

<style lang="scss" scoped>
img {
  @include circle(76px, transparent);
}

p {
  margin-left: 30px;
}

@media (max-width: 991px) {
  img {
    width: 70px;
    height: 70px;
  }

  p {
    margin-left: 10px;
  }
}

@media (max-width: 767px) {
  img {
    width: 103px;
    height: 103px;
  }

  p {
    margin-left: 15px;
  }
}

@media (max-width: 575px) {
  img {
    width: 17.8vw;
    height: 17.8vw;
  }
}
</style>
